import { apiFetch } from '../apiFetch'

export interface FreeConversionItem {
  id: string
  code: string
  free_item_id: string
  material_id: string
  qty_free: number
  free_uom: string
  qty_base: number
  base_uom: string
  factor: number
  status: 'ACTIVE' | 'VOID'
  reason: string
  void_reason?: string | null
  created_by: string
  created_at: string
  voided_at?: string | null
  idempotency_key: string
  free_item_name?: string
  material_name?: string
}

export interface CreateFreeConversionPayload {
  free_item_id: string
  material_id: string
  qty_free: number
  factor?: number | null
  reason: string
}

export async function listFreeConversions(): Promise<FreeConversionItem[]> {
  const res = await apiFetch('/api/free-conversions')
  const body = await res.json()
  if (!res.ok || !body.ok) {
    throw new Error(body?.error?.message || 'Không thể tải danh sách phiếu chuyển sang vật tư')
  }
  return (body.data || []).map((row: any) => ({
    ...row,
    qty_free: Number(row.qty_free ?? 0),
    qty_base: Number(row.qty_base ?? 0),
    factor: Number(row.factor ?? 1),
  }))
}

export async function createFreeConversion(
  payload: CreateFreeConversionPayload,
  idempotencyKey: string,
): Promise<FreeConversionItem> {
  const res = await apiFetch('/api/free-conversions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Idempotency-Key': idempotencyKey,
    },
    body: JSON.stringify(payload),
  })
  const body = await res.json()
  if (!res.ok || !body.ok) {
    const err: any = new Error(body?.error?.message || 'Lỗi khi chuyển hàng tự do sang vật tư')
    err.code = body?.error?.code
    err.status = res.status
    throw err
  }
  const row = body.data
  return {
    ...row,
    qty_free: Number(row.qty_free ?? 0),
    qty_base: Number(row.qty_base ?? 0),
    factor: Number(row.factor ?? 1),
  }
}

export async function voidFreeConversion(
  id: string,
  reason: string,
): Promise<FreeConversionItem> {
  const res = await apiFetch(`/api/free-conversions/${id}/void`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  })
  const body = await res.json()
  if (!res.ok || !body.ok) {
    const err: any = new Error(body?.error?.message || 'Lỗi khi hủy phiếu chuyển đổi')
    err.code = body?.error?.code
    err.status = res.status
    throw err
  }
  const row = body.data
  return {
    ...row,
    qty_free: Number(row.qty_free ?? 0),
    qty_base: Number(row.qty_base ?? 0),
    factor: Number(row.factor ?? 1),
  }
}
